<script setup lang="ts">
  import { Icon } from "@/components/ui/icons"
  import { StepWizardProgressCard } from "@/components/ui/step-wizard"

  const listItems = [
    "Track your energy spending in real-time",
    "Top up via the app or in your local shop",
    "Schedule automatic top-ups in the So Energy Smart Prepay App",
    "Choose payment amounts that work for you",
    "No more unexpected bills",
  ]
</script>

<template>
  <StepWizardProgressCard title="Why Choose Smart Pay As You Go?">
    <div class="space-y-3">
      <p class="mb-4">
        Smart Pay As You Go is ideal if you prefer to pay for energy as you use
        it, want tighter control over your spending, and need more visibility of
        your energy costs.
      </p>

      <h3 class="body-text-strong">Benefits of Smart Pay As You Go:</h3>

      <ul class="space-y-2">
        <li v-for="text in listItems" :key="text" class="flex gap-4">
          <Icon
            name="CircleCheck"
            size="lg"
            class="mt-1 min-w-6 stroke-secondary-400"
          />
          <p>{{ text }}</p>
        </li>
      </ul>
    </div>
  </StepWizardProgressCard>
</template>
